export { default } from "./ownerDocument.mjs";